<template>
  <v-container fluid grid-list-xl>
    <v-layout column>
      <v-flex>
        <update-upload-box></update-upload-box>
      </v-flex>
      <v-flex>
        <update-table></update-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UpdateUploadBox from './UpdateUploadBox.vue';
import UpdateTable from './UpdateTable.vue';

export default {
  components: {
    UpdateUploadBox,
    UpdateTable,
  },
};
</script>

<style>

</style>
